import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { SxErrorService } from 'app/services/sx-error.service';
import { BookingService, CreateAppointmentRequest, CustomQuestion, SchedulingPolicy, Staff, StaffAvailability } from '@model';

@Injectable()
export class BookingsService{
    constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}
    
    getBookingServices(): Observable<BookingService[]> {
        return this.http
          .get<BookingService[]>(`${environment.apiEndpoint}/bookings/services`)
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
      }

    getSchedulingPolicy(bookingBusinessId: string, serviceId: string): Observable<SchedulingPolicy>{
        return this.http
          .post<SchedulingPolicy>(`${environment.apiEndpoint}/bookings/services/${serviceId}/scheduling`, { bookingBusinessId: bookingBusinessId })
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    getStaffs(bookingBusinessId: string, serviceId: string, customerId: string): Observable<Staff[]>{
        return this.http
          .post<Staff[]>(`${environment.apiEndpoint}/bookings/staffs`, { bookingBusinessId: bookingBusinessId, serviceId: serviceId, customerId: customerId })
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    getAvailabilitySlots(bookingBusinessId: string, staffIds: string[], startDate: string, endDate: string): Observable<StaffAvailability[]>{
        return this.http
          .post<StaffAvailability[]>(`${environment.apiEndpoint}/bookings/availability`, { bookingBusinessId: bookingBusinessId, staffIds: staffIds, startDate: startDate, endDate: endDate })
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    createAppointment(request: CreateAppointmentRequest){
        return this.http
          .post(`${environment.apiEndpoint}/bookings/appointment`, request)
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    getServiceCustomQuestions(bookingBusinessId: string, serviceId: string) :Observable<CustomQuestion[]>{
        return this.http
          .post<CustomQuestion[]>(`${environment.apiEndpoint}/bookings/services/${serviceId}/questions`, { bookingBusinessId: bookingBusinessId })
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }
}